import AuthHeaderKeyboardAvoidingView from '@/components/Auth/AuthHeaderKeyboardAvoidingView'
import AuthProfilePinCodeField from '@/components/Auth/ProfilePin/AuthProfilePinCodeField'
import CustomButton from '@/components/UI/buttons/CustomButton'
import CurrentProfileCard from '@/features/auth/components/CurrentProfileCard'
import TitleWithHint from '@/features/auth/components/TitleWithHint'
import { useAppDispatch, useAppSelector } from '@/hooks/redux'
import { clearCurrentAuthProfile } from '@/redux/reducers/auth'
import { authSelectors } from '@/redux/reducers/auth/selectors'
import { Redirect } from 'expo-router'
import { FC } from 'react'
import { useTranslation } from 'react-i18next'

const AuthProfilePinScreen: FC = () => {
    const profile = useAppSelector(authSelectors.currentProfile)

    const dispatch = useAppDispatch()

    const { t } = useTranslation()

    if (!profile) {
        return <Redirect href="/auth/profiles" />
    }

    const handleSelectAnotherAccountButtonPress = () => {
        dispatch(clearCurrentAuthProfile())
    }

    return (
        <AuthHeaderKeyboardAvoidingView>
            <TitleWithHint title={t('profileScreensLogin')} hint={t('profilePinScreenEnterPin')} />
            <CurrentProfileCard
                name={profile.name}
                description={profile.description ?? undefined}
            />
            <CustomButton onPress={handleSelectAnotherAccountButtonPress} style={{ marginTop: 8 }}>
                {t('profilePinScreenSelectAnotherAccount')}
            </CustomButton>
            <AuthProfilePinCodeField />
        </AuthHeaderKeyboardAvoidingView>
    )
}

export default AuthProfilePinScreen
